import { Api } from '../../../typings/api';

export interface ThumbnailData extends Api.EditorThumbnailData {
	imageSrc: string;
}

export enum ThumbnailType {
	COLUMN = 'COLUMN',
	GRID = 'GRID',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/constants.ts